import { WidgetTenantRiskChangesPeriods } from 'models/dto/widgets/widget67DTO';
import { RiskStates } from 'models/riskState';
import { createColorGradient } from './color';
import { enumCount } from './object';

export const getRiskStateColorGradient = (): string[] => {
  const startColor = '#9e44e3';
  const endColor = '#44e364';
  const colors = createColorGradient(startColor, endColor, enumCount(RiskStates));

  return colors;
};

export const getRiskChangesPeriodGradient = (): string[] => {
  const startColor = '#44e359';
  const endColor = '#445ce3';
  const colors = createColorGradient(startColor, endColor, enumCount(WidgetTenantRiskChangesPeriods));

  return colors;
};
